import api from './api';
import { EATERY } from './endpoints';

const get = params => api.get(`${EATERY}/`, { params });

const getById = (id, params = {}) => api.get(`${EATERY}/${id}`, { params });

const getBySlug = (slug, params = {}) =>
  api.get(`${EATERY}/link/${slug}`, { params });

const post = eatery => api.post(`${EATERY}/`, eatery);

const put = eatery => api.put(`${EATERY}/`, eatery);

export default {
  get,
  getById,
  getBySlug,
  post,
  put,
};
